import { ChangeDetectionStrategy, Component, Input, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { InputComponent } from "@components/input/input.component";
import { RadiobuttonGroupComponent } from "@components/radiobuttongroup/radiobuttongroup.component";
import { Observable, forkJoin } from "rxjs";
import { BusyService } from "~app/common/components/busy/busy.service";
import { IRadiobuttonItem } from "~app/common/components/radiobuttongroup/radiobutton/IRadiobuttonItem";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { HandelssortimentSearchService } from "../search-panel/handelssortiment-search.service";
import { HandelssortimentSearchResultViewModel } from "../search-result/handelssortiment-search-result-view-model";

@Component({
    selector: "rask-handelssortiment-file-downloader",
    templateUrl: "./handelssortiment-file-downloader.component.html",
    styleUrls: ["./handelssortiment-file-downloader.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputComponent,
        FormsModule,
        RadiobuttonGroupComponent,
        ButtonComponent
    ]
})
export class HandelssortimentFileDownloaderComponent {
    filnamnPrefix: string;
    violklass: string;
    violklasser: IRadiobuttonItem[];

    @Input() getFileName: (id: number) => string;

    @Input() getSelectedHs: () => HandelssortimentSearchResultViewModel[];
    private readonly busyService = inject(BusyService);
    private readonly handelssortimentSearchService = inject(HandelssortimentSearchService);

    constructor() {
        this.violklasser = [
            { key: "Viol2",
                value: "Viol2" },
            { key: "Viol3",
                value: "Viol3" }
        ] as IRadiobuttonItem[];
        this.violklass = "Viol3";
        this.filnamnPrefix = "";
    }

    download(format: "combinedfdi" | "env" | "singlefdi"): void {
        const selection = this.getSelectedHs();
        let worker: Observable<any>;
        if (format === "singlefdi") {
            worker = new Observable(observer => {
                const observables: Observable<any>[] = [];
                selection.forEach(selected => {
                    const filename = ObjectUtils.stringHasValue(this.filnamnPrefix) ?
                        `${this.filnamnPrefix}_${this.getFileName(selected.id)}` : `${this.getFileName(selected.id)}`;
                    observables.push(this.handelssortimentSearchService.download([selected.beteckning], this.violklass === "Viol3", format, filename));
                });
                forkJoin(observables)
                    .subscribe(() => {
                        observer.next(true);
                        observer.complete();
                    });
            });
        } else {
            worker = this.handelssortimentSearchService.download(selection.map(x => x.beteckning), this.violklass === "Viol3", format, `${this.filnamnPrefix}rask`);
        }

        this.busyService.addWork(worker).subscribe();
    }

}
